<template>
	<div>
		<div class="section-title">
			<i class="label-icon" :class="meta.icon"></i>
			<span class="label-text">{{ meta.title }}</span>
		</div>
		<!-- <div class="category-wrapper d-flex justify-content-between">
			<div class="category-nav" ref="category">
				<div v-for="(category, index) in categories" :key="index" :class="{'active' : selectedCategory.slug === category.slug}" @click="setSelectedCategory(category)">
					<img :src="category.image_url" alt="icon" width="24" />
					<span>{{ category.name }}</span>
				</div>
			</div>
			<div class="category-next" @click="doScroll">
				<i class="bi text-primary" :class="{ 'bi-chevron-double-right': arrowRight, 'bi-chevron-double-left': !arrowRight }"></i>
			</div>
		</div> -->
		<div class="dropship-categories">
			<div class="pc-box box p-0">
				<div class="d-flex flex-wrap">
					<div
						class="col-md-3 col-6 dropship-categories-item"
						:class="{
							'active-category': selectedCategory.slug === category.slug,
							'text-primary': selectedCategory.slug === category.slug,
						}"
						v-for="(category, index) in categories"
						:key="index"
					>
						<div
							@click="setSelectedCategory(category)"
							class="p-3 d-flex align-items-center"
						>
							<img :src="category.image_url" alt="icon" width="36" />
							<span class="ml-2 d-xl-none">
								{{ category.name.length > 10 ? `${category.name.substring(0,10)}...` : category.name }}
							</span>
							<span class="ml-2 d-none d-sm-none d-md-none d-lg-none d-xl-block category">
								{{ category.name }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="section-title text-left">
			<span class="label-text">{{ selectedCategory.name }}</span>
			<span class="ml-2 text-bold">
				<a :href="'/search?c='+ selectedCategory.slug" class="text-decoration-none">Lihat semua</a>
			</span>
		</div>
		<div class="row product-items">
			<template v-if="isFetchingProducts && page === 1">
				<div v-for="(product, index) in dummyProducts" :key="'dummy1-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
					<product-item :is-loading="isFetchingProducts" />
				</div>
			</template>
			<template>
				<template v-if="products.length > 0">
					<div v-for="(product, index) in products" :key="'product-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
						<product-item :product="product" @showDetail="showDetail(product)" />
					</div>
					<template v-if="isFetchingProducts">
						<div v-for="(product, index) in dummyProducts" :key="'dummy2-'+index" class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center product-item">
							<product-item :is-loading="isFetchingProducts" />
						</div>
					</template>
					<div class="col-12 d-flex justify-content-center" v-if="isLoadMoreEnabled">
						<button type="button" class="btn-outline o-lg outline-primary" @click="loadMore">Muat Lebih Banyak</button>
					</div>
					<div class="col-12 d-flex justify-content-center" v-else-if="isShowAllProductEnabled">
						<button type="button" class="btn-outline o-lg outline-primary" @click="showAllProduct">Lihat Semua</button>
					</div>
				</template>
				<template v-else>
					<div class="col-12">
						<div class="card card-body card-product-empty border-0 d-flex mb-4">
							<div class="empty-description">
								Oops, produk dengan kategori <strong>"{{ this.selectedCategory.name }}"</strong> tidak ditemukan. Silahkan coba kategori lainnya.
							</div>
						</div>
					</div>
				</template>
			</template>
		</div>

		<!-- <div class="d-flex justify-content-between">
			<pagination
				v-if="totalPages > 1"
				:total-pages="totalPages"
				:total="totalItems"
				:per-page="itemsPerPage"
				:current-page="page"
				:max-visible-buttons="maxVisibleButtons"
				@pagechanged="onPageChange"
			/>
			<div v-else></div>
			<div v-if="products.length > 0">
				<button class="btn btn-plain text-primary" @click="showAllProduct()">Lihat Semua</button>
			</div>
		</div> -->
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import ProductItem from '@/components/homepages/sections/partials/ProductItem.vue';
// import Pagination from '@/components/homepages/Pagination.vue';
import homepageApi from '@/api/homepage';
import { dropshipCategories, paginationMaxVisibleButtons } from '@/lib/statics';
import {
	formatNumber,
	formatMoney,
	duplicateVar,
} from '@/lib/helper';

export default {
	name: 'ProductCategory',
	components: {
		ProductItem,
		// Pagination,
	},
	props: {
		meta: {
			type: Object,
			default: () => ({
				title: 'Kategori Produk',
				icon: 'bi-bag-check',
				source: 'static',
			}),
		},
	},
	data() {
		return {
			keyword: '',
			limit: 12,
			page: 1,
			sort_by: 'random',
			sort: 'desc',
			totalPages: 0,
			totalItems: 0,
			itemsPerPage: 8,
			maxVisibleButtons: 7,
			scrollAmount: 0,
			arrowRight: true,
			dummyProducts: new Array(12),
			categories: dropshipCategories,
			selectedCategory: {
				name: 'Semua Kategori',
				image_url: 'https://cdn.ostock.id/icons/category/lainnya.svg',
				slug: 'all',
			},
			products: [],
			isFetchingProducts: true,
			isShowAllProductEnabled: false,
			isLoadMoreEnabled: true,
			scrollPosition: 0,
		};
	},
	methods: {
		duplicateVar,
		formatNumber(number) {
			return formatNumber(number, 0, ',', '.');
		},
		formatMoney,
		scrollLeft() {
			const menu = this.$refs.category;
			menu.scrollTo({
				left: this.scrollAmount += 400,
				behavior: 'smooth',
			});
			if ((Math.ceil(Math.abs(menu.scrollLeft))) >= (menu.scrollWidth - menu.clientWidth)) {
				this.arrowRight = false;
			}
		},
		scrollRight() {
			const menu = this.$refs.category;
			menu.scrollTo({
				left: this.scrollAmount -= 400,
				behavior: 'smooth',
			});
			if ((Math.ceil(Math.abs(menu.scrollLeft))) < 1) {
				this.arrowRight = true;
			}
		},
		doScroll() {
			if (this.arrowRight) {
				this.scrollLeft();
			} else {
				this.scrollRight();
			}
		},
		showDetail(product) {
			const encodedUserId = window.btoa(product.user._id.$oid);
			this.$router.push({ name: 'product-detail', params: { slug: `${product.slug}-${encodedUserId}` } });
		},
		resetLoadMoreButton() {
			this.isShowAllProductEnabled = false;
			this.isLoadMoreEnabled = true;
		},
		setSelectedCategory(category) {
			this.page = 1;
			this.selectedCategory = category;

			const params = `?category=${category.slug}`;

			window.history.pushState({}, '', params);
			this.resetLoadMoreButton();
		},
		onPageChange(page) {
			this.page = page;
			this.fetchProducts();
		},
		fetchProducts(reset = false) {
			this.isFetchingProducts = true;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				// status: this.status,
				is_randomized: true,
				use_cache_header: true,
			};

			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}

			if (this.selectedCategory !== '' && this.selectedCategory.slug !== 'all') {
				params.category = this.selectedCategory.slug;
			}

			const sessionId = sessionStorage.getItem('sessionId');
			if (sessionId) {
				params.session_id = sessionId;
			}

			if (this.user) {
				params.user_id = this.user?._id?.$oid ?? this.user?._id;
			}

			const callback = (response) => {
				const products = response.data.products;
				if (reset) {
					this.products = products;
				} else {
					this.products = [...this.products, ...products];
				}

				this.totalPages = response.data.page_info.last_page;
				this.totalItems = response.data.page_info.total_all_products;
				this.itemsPerPage = response.data.page_info.total_products;

				if (this.totalPages > 1 && this.page > 3) { // allow load more 3 times
					this.isLoadMoreEnabled = false;
					this.isShowAllProductEnabled = true;
				} else if (this.totalPages <= 1) { // total pages decrease as the products pushed into array, total pages 1 means the last page
					this.isLoadMoreEnabled = false;
					this.isShowAllProductEnabled = false;
				}

				// set pagination max visible button
				this.maxVisibleButtons = this.totalPages;
				if (this.totalPages > paginationMaxVisibleButtons) {
					this.maxVisibleButtons = paginationMaxVisibleButtons;
				}

				this.isFetchingProducts = false;
			};

			const errorCallback = () => {
				this.products = [];
				this.page = 1;
				this.totalPages = 0;
				this.totalItems = 0;
				this.maxVisibleButtons = paginationMaxVisibleButtons;
				this.isFetchingProducts = false;
			};

			homepageApi.getPublicProducts(params, callback, errorCallback);
		},
		showAllProduct() {
			this.$router.push({ path: '/search', query: { c: this.selectedCategory.slug } });
		},
		loadMore() {
			this.dummyProducts = new Array(this.products.length);
			this.page++;
			this.fetchProducts();
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	watch: {
		'$route.query': {
			handler() {
				const query = this.duplicateVar(this?.$router?.currentRoute.query);
				if (this.categories) {
					this.selectedCategory = duplicateVar(this.categories.find(x => x?.slug === query.category));
				}
			},
		},
		selectedCategory: {
			handler() {
				this.fetchProducts(true);
			},
		},
		user() {
			this.fetchProducts(true);
		},
	},
	mounted() {
		const query = this.$router.currentRoute.query;

		if (query.category) {
			if (this.categories) {
				this.selectedCategory = duplicateVar(this.categories.find(x => x?.slug === query.category));
			}
		}

		if (this.meta.source !== 'static') {
			this.fetchProducts();
		}
	},
};
</script>
<style lang="scss" scoped>
	@import '../../../assets/scss/modules/_variables.scss';

	.section-title {
		// margin-left: 40px;
		margin-bottom: 10px;
		.label-icon {
			font-size: 32px;
			color: #D66956;
			margin-right: 20px;
		}
		.label-text {
			font-style: normal;
			font-weight: 600;
			font-size: 28px;
			color: #4D4D4D;
		}
	}

	.category-nav {
		margin-left: 20px;
		margin-right: 10px;
		margin-bottom: 15px;
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;
		&::-webkit-scrollbar { width: 0 !important }

		div {
			display: inline-block;
			margin-right: 20px;
			padding-left: 20px;
			padding-right: 20px;
			cursor: pointer;

			span {
				color: rgba(27, 28, 30, 0.87);
				text-align: center;
				padding-top: 14px;
				padding-bottom: 14px;
				padding-left: 10px;
				font-size: 16px;
				font-weight: 700;
			}

			img {
				margin-bottom: 7px;
			}

			&:hover {
				border-bottom: 2px solid $color__primary;
			}

			&.active {
				border-bottom: 2px solid $color__primary;
			}
		}
	}

	.category-next {
		margin-left: 40px;
		margin-right: 50px;
		cursor: pointer;
		font-size: 1.4em;

		@media screen and (max-width: 540px) {
			margin-left: 0px;
			margin-right: 10px;
		}
	}

	.card-product-empty {
		border-radius: 5px;
		padding: 30px;
	}

	.pc-box {
		&.box {
			border-radius: 5px;
			overflow: hidden;
		}
	}

	.product-item {
		padding-left: 8px;
		padding-right: 8px;
	}
	.row.product-items {
		margin-left: -8px;
		margin-right: -8px;
	}
</style>
